export default __webpack_public_path__ + "static/media/House_icon_green.13f0d2c2.webp";